import { render } from "./Warehouse.vue?vue&type=template&id=ff421c9a"
import script from "./Warehouse.vue?vue&type=script&lang=js"
export * from "./Warehouse.vue?vue&type=script&lang=js"

import "./Warehouse.vue?vue&type=style&index=0&id=ff421c9a&lang=css"

import exportComponent from "/usr/src/nuxt-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__